import { css } from '@repo/pandacss/styled-system/css';
import { ProductCardSkeleton } from '../ProductCard/Skeleton';
import { CategorySectionTitleSkeleton } from './CategorySectionTitleSkeleton';

type Props = {
  cardsAmount: number;
  showTitleSkeleton: boolean;
  isOurTakeExpanded: boolean;
};

export const ProductCardCategorySectionsSkeleton = ({
  cardsAmount,
  showTitleSkeleton,
  isOurTakeExpanded,
}: Props) => {
  return (
    <div
      className={css({
        maxWidth: { base: 'full', md: '[82%]' },
        marginInlineStart: 'auto',
        marginInlineEnd: 'auto',
        marginTop: { base: '11', md: '8' },
        '&:first-of-type': { marginTop: '0' },
      })}
    >
      {showTitleSkeleton && <CategorySectionTitleSkeleton />}
      {Array.from({ length: cardsAmount }).map((_, index) => (
        <div key={`card-skeleton-${index}`}>
          <ProductCardSkeleton ourTakeExpanded={isOurTakeExpanded} />
        </div>
      ))}
    </div>
  );
};
